module.exports = __webpack_public_path__ + "img/001.f03058a9.png";